


























import { Prop } from 'vue-property-decorator';
import Component, { mixins } from 'vue-class-component';

import ListItem from '@/components/Atoms/ListItem/Attention.vue';
import TextLink from '@/components/Atoms/Link/TextLink.vue';
import OrderedList from '@/components/Atoms/List/OrderedListSmallFont.vue';
import UrlMixin from '@/mixins/url';

@Component({
  components: {
    ListItem,
    TextLink,
    OrderedList,
  },
})
export default class PhoneOptionAttention extends mixins(UrlMixin) {
  @Prop() phone_id!: string;

  get both() {
    return ['basic', 'ace'].includes(this.phone_id);
  }

  get onlyBasic() {
    return ['basic'].includes(this.phone_id);
  }
}
